/// <amd-module name="Artifacts/Pypi/commands/PermanentDelete" />
import { PypiActions } from "Artifacts/Pypi/redux";
import { getPermanentDeleteCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createPermanentDeleteCommand = getPermanentDeleteCommandCreator(
  PypiActions.permanentDelete,
);
